import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { VehicleDetails } from './details';
import { VehiclesOverview } from './overview';
import { VehicleCreate } from './create/index';
import { VehicleEdit } from './create/edit';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class VehiclesPageComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  render() {
    return (
      <Container>
        <Switch>
          <Route
            path="(.*)/vehicles/create/:step/:vehicleId?"
            render={component => (
              <VehicleCreate
                vehicle_id={parseInt(component.match.params.vehicleId, 10)}
                step={parseInt(component.match.params.step, 10)}
              />
            )}
          />
          <Route
            path="(.*)/vehicles/:id/edit/:step?"
            render={component => (
              <VehicleEdit
                key={`${component.match.params.id}-${component.match.params.step}`}
                vehicle_id={parseInt(component.match.params.id, 10)}
                step={parseInt(component.match.params.step, 10)}
              />
            )}
          />
          <Route
            path="(.*)/vehicles/:id(.*)"
            render={component => <VehicleDetails vehicle_id={parseInt(component.match.params.id, 10)} />}
          />
          <Route component={VehiclesOverview} />
        </Switch>
      </Container>
    );
  }
}

VehiclesPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const VehiclesPage = compose(
  withConnect,
  withRouter,
)(VehiclesPageComp);
